import { useState } from 'react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, SearchField, styles, useFormField } from '@frontend/design-system';

export const TrayContent = () => {
  const { t } = useTranslation('schedule-quick-fill');
  const [isSelectionModeOn, setSelectionMode] = useState(false);
  const searchField = useFormField({ type: 'text' });
  // const debouncedSearchTerm = useDebouncedValue(searchField.value);

  const handleSelectAllToggle = () => {
    setSelectionMode((prev) => !prev);
    // TODO: Implement select/deselect all logic
  };

  return (
    <section css={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <header css={{ padding: theme.spacing(0, 3) }}>
        <SearchField name='search' {...searchField} />
        <div css={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            variant='tertiary'
            iconName='select-all'
            css={{ padding: theme.spacing(0.25) }}
            onClick={handleSelectAllToggle}
          >
            {isSelectionModeOn ? t('Deselect All') : t('Select All')}
          </Button>
          {/* // Add functionality to the Add to List button later */}
          <Button
            variant='tertiary'
            iconName='add'
            css={{ padding: theme.spacing(0.25), display: !isSelectionModeOn ? 'block' : 'none' }}
          >
            {t('Add to List')}
          </Button>
        </div>
      </header>
      <div css={{ flex: 1 }}>{/* // TODO: add person list with selection checkboxes */}</div>
      <footer css={[styles.flexCenter, { gap: theme.spacing(1), padding: theme.spacing(3) }]}>
        <Button variant='secondary' disabled={!isSelectionModeOn}>
          {t('Cancel')}
        </Button>
        <Button disabled={!isSelectionModeOn}>{t('Send Message')}</Button>
      </footer>
    </section>
  );
};
